// Module
var code = "<svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" width=\"1600.000000pt\" height=\"1600.000000pt\" viewBox=\"0 0 1600.000000 1600.000000\" preserveAspectRatio=\"xMidYMid meet\"> <g transform=\"translate(0.000000,1600.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\"> </g> </svg>";
// Exports
module.exports = code;